import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Button } from "@chakra-ui/react";
import _ from "lodash";
import * as actions from "../../../redux/actions";

export default function EditSubCategory() {
  const { register, handleSubmit, errors } = useForm();
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const subCategory = useSelector((state) => state.sub_category_vehicle);

  useEffect(() => {
    dispatch(actions.categoryAll());
    dispatch(actions.sub_category_vehicleGet(id)).then(() => {
      setIsLoading(true);
    });
    return () => { };
  }, []);

  const onSubmit = (data, e) => {
    dispatch(actions.sub_category_vehiclePut(id, data)).then(() => {
      history.push("/fms/category/detail/" + subCategory.category_id);
    });
  };
  return (
    <div>
      <div>
        <h2 className="text-gray-800 text-xl font-semibold">
          {" "}
          แก้ไขหมวดหมู่ย่อย
        </h2>
      </div>
      <div className="flex py-4 justify-between">
        <div>
          <Link to={`/fms/category/detail/${subCategory?.category_id}`}>
            <Button variant="outline">กลับ</Button>
          </Link>
        </div>
      </div>
      <div className="p-4">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-6/12 px-4">
            {" "}
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="relative w-full mb-3">
                <label
                  className="block uppercase text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  ชื่อหมวดหมู่ย่อย <label className="text-red-600 text-xs"> *</label>
                </label>
                <input
                  name="sub_category_name"
                  type="text"
                  required
                  ref={register}
                  defaultValue={subCategory?.sub_category_name}
                  className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                  placeholder="ชื่อหมวดหมู่ย่อย"
                />
              </div>
              <div className="text-center mt-6">
                <Button isFullWidth colorScheme="blue" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
